module.exports = __webpack_public_path__ + "static/media/Getty_Images_160375427_mobile.90efe44e.jpg";